import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-1" }
const _hoisted_2 = {
  style: {"font-size":"12px"},
  class: "d-flex justify-space-between m-1"
}

import SingleOperationOfficeAutoComplete from '@/components/AutoCompletes/SingleOperationOfficeAutoComplete.vue';
import getUnexpectedEventAndAlertStatuses from "@/types/requests/getUnexpectedEventAndAlertStatuses.vue";
import ManagementOfficeAutoComplete from '@/components/AutoCompletes/ManagementOfficeAutoComplete.vue';
import DepartmentAutoComplete from '@/components/AutoCompletes/DepartmentAutoComplete.vue';
import { SELECTABLE_STATUSES } from '@/services/consts/unecpected_event_and_alert_status';
import VehicleAutoComplete from '@/components/AutoCompletes/VehicleAutoComplete.vue';
import DriverAutoComplete from '@/components/AutoCompletes/DriverAutoComplete.vue';
import GroupAutoComplete from '@/components/AutoCompletes/GroupAutoComplete.vue';
import ValidationErrors from '@/components/Common/ValidationErrors.vue';
import RangeDatePicker from '@/components/Common/RangeDatePicker.vue';
import SelectBox from "@/components/Common/selectBox.vue";
import { computed } from 'vue';
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchFormContent',
  props: {
    modelValue: {},
    maxFilterDays: {},
    errors: {},
    operationOfficeClearable: { type: Boolean },
    isManagementOffice: { type: Boolean },
    isDepartment: { type: Boolean }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit
const props = __props

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits('update:modelValue', value);
  },
})


return (_ctx: any,_cache: any) => {
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ManagementOfficeAutoComplete, {
      modelValue: modelValue.value.managementOffice,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue.value.managementOffice) = $event)),
      selectFirstIfOnlyOne: "",
      clearable: props.isManagementOffice
    }, null, 8, ["modelValue", "clearable"]),
    _createVNode(SingleOperationOfficeAutoComplete, {
      modelValue: modelValue.value.operationOffice,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modelValue.value.operationOffice) = $event)),
      managementOffice: modelValue.value.managementOffice,
      "error-messages": __props.errors.operationOffice,
      selectFirstIfOnlyOne: "",
      clearable: props.operationOfficeClearable
    }, null, 8, ["modelValue", "managementOffice", "error-messages", "clearable"]),
    _createVNode(GroupAutoComplete, {
      modelValue: modelValue.value.group,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((modelValue.value.group) = $event)),
      managementOffice: modelValue.value.managementOffice,
      operationOffices: [modelValue.value.operationOffice]
    }, null, 8, ["modelValue", "managementOffice", "operationOffices"]),
    _createVNode(DepartmentAutoComplete, {
      modelValue: modelValue.value.department,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((modelValue.value.department) = $event)),
      operationOffices: [modelValue.value.operationOffice],
      selectFirstIfOnlyOne: __props.isDepartment
    }, null, 8, ["modelValue", "operationOffices", "selectFirstIfOnlyOne"]),
    _createVNode(VehicleAutoComplete, {
      modelValue: modelValue.value.vehicle,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((modelValue.value.vehicle) = $event)),
      selectedDepartment: modelValue.value.department,
      managementOffice: modelValue.value.managementOffice,
      operationOffices: [modelValue.value.operationOffice],
      requestParams: { type: 'filter' }
    }, null, 8, ["modelValue", "selectedDepartment", "managementOffice", "operationOffices"]),
    _createVNode(DriverAutoComplete, {
      modelValue: modelValue.value.driver,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((modelValue.value.driver) = $event)),
      selectedDepartment: modelValue.value.department,
      operationOffices: modelValue.value.operationOffice ? [modelValue.value.operationOffice] : []
    }, null, 8, ["modelValue", "selectedDepartment", "operationOffices"]),
    _createVNode(SelectBox, {
      class: "pt-2",
      modelValue: modelValue.value.division,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((modelValue.value.division) = $event)),
      label: _unref(i18n).global.t('pages.unexpectedEventAndAlertStatuses.filter.selectDivision.title'),
      items: _unref(SELECTABLE_STATUSES),
      clearable: false
    }, null, 8, ["modelValue", "label", "items"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_radio_group, {
        modelValue: modelValue.value.includes_start_or_end_time,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((modelValue.value.includes_start_or_end_time) = $event)),
        class: "radio-group-row"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_radio, {
            value: "start_time",
            label: _unref(i18n).global.t('pages.common.filter.startTime'),
            color: "blue"
          }, null, 8, ["label"]),
          _createVNode(_component_v_radio, {
            value: "end_time",
            label: _unref(i18n).global.t('pages.common.filter.endTime'),
            color: "blue"
          }, null, 8, ["label"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createVNode(ValidationErrors, {
      messages: __props.errors.start_time
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(RangeDatePicker, {
            modelValue: modelValue.value.dateRange,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((modelValue.value.dateRange) = $event)),
            maxRange: props.maxFilterDays,
            format: 'yyyy/MM/dd',
            isError: __props.errors.start_time?.length > 0
          }, null, 8, ["modelValue", "maxRange", "isError"])
        ])
      ]),
      _: 1
    }, 8, ["messages"])
  ], 64))
}
}

})